<template>
  <el-row>
    <el-col :span="24">
      <h4>Contact Information</h4>
      <a>{{header.shiptoemail}}</a>
      <h4>Shipping Address</h4>
      <div>{{header.shiptocompany}} {{header.shiptocontact}}</div>
      <div>{{header.shiptoaddress1}}</div>
      <div>{{header.shiptoaddress2}}</div>
      <div>{{header.shiptocity}} {{header.shiptostate}} {{header.shiptozip}}</div>
      <div>{{header.shiptocountry}}</div>
      <div>{{header.shiptophone}}</div>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'LogOnHeader',
    props: {
      /*
      * The props are everything that we get from LogOn on an order lookup.
      * The unused ones are left in here since this will be reused on the OCA
      * and RAA at some point.
      */
      header: {
        required: true,
        type: Object,
        ordnum: {
          required: false,
        },
        ponum: {
          required: false,
        },
        sotype: {
          required: false,
        },
        orddate: {
          required: false,
        },
        startship: {
          required: false,
        },
        cancel: {
          required: false,
        },
        billtoccode: {
          required: false,
        },
        shiptocext: {
          required: false,
        },
        shiptocontact: {
          required: true,
        },
        shiptocompany: {
          required: true,
        },
        shiptoaddress1: {
          required: true,
        },
        shiptoaddress2: {
          required: false,
          default: '',
        },
        shiptocity: {
          required: true,
        },
        shiptostate: {
          required: true,
        },
        shiptozip: {
          required: true,
        },
        shiptocountry: {
          required: true,
        },
        shiptophone: {
          required: true,
        },
        shiptoemail: {
          required: true,
        },
        shipvia: {
          required: false,
        },
        freight: {
          required: false,
        },
        tax: {
          required: false,
        },
        taxperc: {
          required: false,
        },
        taxcode: {
          required: false,
        },
        note: {
          required: false,
        },
        msg: {
          required: false,
        },
        crefnum: {
          required: false,
        },
        currency: {
          required: false,
        },
        scode: {
          required: false,
        },
        priceoverridereasoncode: {
          required: false,
        },
      },
    },
  };
</script>
